var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNoTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 326.9 121.3",
    style: {
      enableBackground: "new 0 0 326.9 121.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004D9F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-349.05 -304.34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.6,320.7V341h14v15.7h-14V399c0,3.2,0.7,5.5,2,6.9c1.4,1.4,3.4,2.2,5.4,2.1c1,0,2-0.1,3-0.2 c1-0.2,2-0.4,3-0.7l1.9,16.2c-2.2,0.7-4.4,1.3-6.6,1.7c-2.3,0.4-4.7,0.6-7,0.6c-7.7,0-13.7-2.1-17.9-6.4c-4.2-4.2-6.3-11-6.2-20.2 v-42.4h-12.1V341h12.1v-20.3H383.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.4,321.2H413v-16.8h22.4L435.4,321.2z M435.4,424.1H413V341h22.4L435.4,424.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.9,394c-0.1-5.6,1.6-11.1,5-15.6c3.3-4.4,8.4-8.9,15.2-13.7c-3.1-4-5.7-8.3-7.8-12.9 c-1.7-3.7-2.6-7.8-2.6-11.9c0-8.9,2.8-15.9,8.3-21.2s12.9-7.9,22.2-7.9c8.1,0,14.8,2.5,19.8,7.6c5,4.8,7.7,11.4,7.6,18.3 c0,4.8-1.3,9.6-3.8,13.7c-2.7,4.3-6.2,8-10.3,10.9l-7.1,5.1l21.2,24.7c3.9-6.4,5.9-13.8,5.8-21.3h16.7c0.1,6.6-0.8,13.2-2.6,19.5 c-1.6,5.7-4.4,11.1-8,15.8l16,18.7l-0.2,0.4h-24.9l-5.9-6.8c-4.2,2.7-8.7,4.9-13.4,6.3c-4.8,1.4-9.8,2.1-14.8,2.1 c-11.2,0-20-2.9-26.6-8.8C453.2,411,449.9,403.4,449.9,394L449.9,394z M487.6,408.4c5.6,0,11.1-1.4,16-4.1l-23-26.6l-1.5,1 c-2.3,2-4.1,4.4-5.3,7.2c-0.9,2.2-1.4,4.6-1.4,7c-0.2,4.1,1.3,8.2,4.2,11.2C479.4,407,483.4,408.6,487.6,408.4L487.6,408.4z  M479.8,339.7c0,2.4,0.6,4.7,1.6,6.8c1.4,2.7,3.1,5.3,5,7.7l6.6-4.3c2.4-1.4,4.4-3.3,5.8-5.7c1-2,1.5-4.2,1.5-6.4 c0-2.6-1-5-2.8-6.8c-1.9-2-4.6-3.1-7.3-3c-2.9-0.2-5.8,1.1-7.7,3.3C480.6,333.7,479.7,336.6,479.8,339.7L479.8,339.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M577.9,341l0.9,11c2.5-3.9,6-7,10-9.2c4.3-2.2,9.1-3.4,13.9-3.3c4.8-0.1,9.5,1.1,13.7,3.5 c3.9,2.5,6.9,6.3,8.6,10.7c2.4-4.3,5.8-7.9,10-10.4c4.4-2.6,9.4-3.9,14.4-3.8c8.2,0,14.6,2.8,19.4,8.5c4.7,5.7,7.1,14.3,7.1,25.8 v50.3h-22.4v-50.5c0-6.3-1-10.7-3.1-13.1c-2-2.5-5.1-3.7-9.1-3.7c-2.9-0.1-5.7,0.7-8.2,2.1c-2.3,1.4-4.3,3.5-5.6,5.9 c0,1,0,1.8,0.1,2.5s0.1,1.4,0.1,2.1v54.7h-22.3v-50.5c0-6.2-1-10.5-3.1-13c-2-2.5-5.1-3.8-9.2-3.9c-2.7-0.1-5.5,0.5-7.9,1.7 c-2.3,1.1-4.2,2.8-5.6,4.9v60.7h-22.3V341H577.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoTag);
export default __webpack_public_path__ + "static/media/logo_no_tag.6c9278ce56a3c498055665f3516c2852.svg";
export { ForwardRef as ReactComponent };